import Input from '@/components/Common/Input';
import { Box, Paper, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';

export default function DuringCallSmsConfig() {
  const { control } = useFormContext();

  return (
    <Paper variant='outlined' sx={{ p: 3 }}>
      <Box mb={2} px={2} py={1.5} borderRadius={2} border='1px solid #D97706' bgcolor='#FFFBEB' color='#D97706'>
        <Typography fontSize={14} fontWeight={500} mb={0.5}>
          SMS setup requirements vary by country:
        </Typography>
        <Box component='ul' sx={{ m: 0, pl: 2.5 }}>
          <Typography component='li' fontSize={14} sx={{ mb: 0.5 }}>
            In the United States, A2P Brand and Campaign registration is required.
          </Typography>
          <Typography component='li' fontSize={14}>
            In Canada, SMS is available with Kickcall-provided phone numbers, while customer-owned numbers require SMS
            hosting to be enabled.
          </Typography>
        </Box>
      </Box>

      <Input
        name='send_sms_to_caller_details.message_content'
        control={control}
        label='SMS Message Template'
        placeholder='e.g: Hi {name}, your appointment at Healthcare Plus is confirmed for {date} at {time}. Reply C to cancel.'
        multiline
        rows={3}
        fullWidth
        required
      />

      <Box mt={2}>
        <Input
          name='send_sms_to_caller_details.trigger'
          control={control}
          label='When to Send'
          placeholder='e.g: After an appointment is booked or rescheduled'
          fullWidth
          required
        />
      </Box>
    </Paper>
  );
}
